var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1.78196 5.73333 5.51456 2.5 10 2.5C14.4854 2.5 18.2172 5.73333 19 10C18.218 14.2667 14.4854 17.5 10 17.5C5.51456 17.5 1.78279 14.2667 1 10ZM10 14.1667C11.1031 14.1667 12.1611 13.7277 12.9411 12.9463C13.7211 12.1649 14.1593 11.1051 14.1593 10C14.1593 8.89493 13.7211 7.83512 12.9411 7.05372C12.1611 6.27232 11.1031 5.83333 10 5.83333C8.89687 5.83333 7.83893 6.27232 7.0589 7.05372C6.27887 7.83512 5.84065 8.89493 5.84065 10C5.84065 11.1051 6.27887 12.1649 7.0589 12.9463C7.83893 13.7277 8.89687 14.1667 10 14.1667ZM10 12.5C9.33812 12.5 8.70335 12.2366 8.23534 11.7678C7.76732 11.2989 7.50439 10.663 7.50439 10C7.50439 9.33696 7.76732 8.70107 8.23534 8.23223C8.70335 7.76339 9.33812 7.5 10 7.5C10.6619 7.5 11.2966 7.76339 11.7647 8.23223C12.2327 8.70107 12.4956 9.33696 12.4956 10C12.4956 10.663 12.2327 11.2989 11.7647 11.7678C11.2966 12.2366 10.6619 12.5 10 12.5Z",
    fill: "#13161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.027c7f2e33ce4bd533a6e3c5948cd066.svg";
export { ForwardRef as ReactComponent };